export default "<div class=\"proxy-response-iframe iframe-cont\">\r\n\t<html-viewer content=\"$ctrl.content\"></html-viewer>\r\n</div>";